import React from 'react';
import Header from '../components/Header';
import Shops from '../components/Shops';
const Home = () => {
    return (
        <div>
            <Header />
            <Shops/>
            </div>
    );
};
export default Home;